import {useCollection} from '../../firebase/hooks/useCollection';
import {Collection} from '../../firebase/types';
import {SignupRule} from '#common/auth/rules';
import {SignupList, SignupRuleType} from '#common/firebase/collections';
import {EntityTypeSuffix, TypedIdGenerator, defaultTypedIdGenerator} from '#common/models/Entity';

const SignupRuleIdSuffix = 'sr' as const satisfies EntityTypeSuffix;
export const SignupRuleIdGenerator: TypedIdGenerator<SignupRule> = defaultTypedIdGenerator(SignupRuleIdSuffix);

export function useSignupRuleCollection(type: SignupRuleType): Collection<SignupRule> {
  return useCollection<SignupRule>(SignupRuleIdGenerator, SignupList[type]);
}
